import { Component, HostBinding, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterOutlet } from '@angular/router';
import { Location, NgIf } from '@angular/common';
import { Subscription, switchMap } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

import { pageTransitions } from '../../../shared/animations/page-transitions';
import { OrganizationService } from '../../services/organization.service';
import { OrganizationDetails } from '../../models/organization-details';
import { BackButtonComponent } from '../../../shared/components/back-button/back-button.component';

@Component({
	selector: 'copo-organization-card',
	templateUrl: './organization-card.component.html',
	styleUrl: './organization-card.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,

	imports: [BackButtonComponent, TranslateModule, MatButtonModule, RouterLink, NgIf, RouterOutlet]
})
export class OrganizationCardComponent implements OnInit, OnDestroy {
	@HostBinding('class.passthrough') readonly passthrough = true;

	organization?: OrganizationDetails;
	orgNameSubscription: Subscription;
	private componentSubscription?: Subscription;

	constructor(
		private readonly location: Location,
		private readonly router: Router,
		private readonly organizationService: OrganizationService,
		private readonly route: ActivatedRoute
	) {
		this.orgNameSubscription = this.organizationService.subscribeToOrgName({
			next: orgName => {
				if (orgName && this.organization) {
					this.organization.name = orgName;
				}
			}
		});
	}

	isActivate(suffix: string) {
		return this.router.url.endsWith(suffix);
	}

	ngOnInit() {
		this.componentSubscription = this.route.paramMap.pipe(
			switchMap(params => {
				const idString = params.get('id');
				return idString ? this.organizationService.findOrganizationDetails(idString) : [];
			})
		).subscribe({
			next: response => {
				this.organization = response;
			},
			error: (err: unknown) => {
				console.error('Error while fetching organization', err);
			}
		});
	}

	getBack() {
		this.location.back();
	}

	ngOnDestroy() {
		if (this.componentSubscription) {
			this.componentSubscription.unsubscribe();
		}
		this.orgNameSubscription.unsubscribe();
	}
}
